import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CostComparisonSection } from './components/CostComparisonSection';
import { PricingSection } from './components/PricingSection';
import { KitControlSection } from './components/KitControlSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FaqSection } from './components/FaqSection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { SiteFooter } from './components/SiteFooter';
import { StickyCta } from './components/StickyCta';
import { testimonialsBlockOne, testimonialsBlockTwo } from './data/testimonials';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-cream font-sans text-body" data-id="element-0" data-mp="3mjq45l4rr2xp">
      <Hero data-id="element-1" data-mp="3rbzngibdp4r0" />
      <main data-id="element-2" data-mp="3rdkisa5iorpx">
        <PainSection data-id="element-3" data-mp="3rcsxbs5mwadd" />
        <MechanismSection data-id="element-4" data-mp="3reltgdimfc74" />
        <ProductSection data-id="element-5" data-mp="6hqtghuuhen" />
        <TomosSection data-id="element-6" data-mp="4ww9qvjiygs" />
        <BonosSection data-id="element-7" data-mp="56mnfkhz7n0" />
        <TestimonialsSection id="testimonios-1" title="Personas reales. Cocinas reales. Resultados reales." items={testimonialsBlockOne} data-id="element-8" data-mp="7stte3h7l4p" />
        <CostComparisonSection data-id="element-9" data-mp="33mykvbp88ntn" />
        <PricingSection data-id="element-10" data-mp="38lrs4mdx7ild" />
        <KitControlSection data-id="element-11" data-mp="38li77d7qg1mj" />
        <TestimonialsSection id="testimonios-2" title="Más personas que ya recuperaron su cocina — y su tranquilidad" items={testimonialsBlockTwo} tone="dark" data-id="element-12" data-mp="38k6w0sbyjrle" />
        <GuaranteeSection data-id="element-13" data-mp="nvaszup2llhp" />
        <UrgencySection data-id="element-14" data-mp="sunadzx6a0cw" />
        <FaqSection data-id="element-15" data-mp="stuexv3nyxa2" />
        <FinalCloseSection data-id="element-16" data-mp="stc7s3fgqynd" />
      </main>
      <SiteFooter data-id="element-17" data-mp="swgm3tmn7arr" />
      <StickyCta data-id="element-18" data-mp="3688dot76uy6" />
    </div>;
}